import { Injectable } from '@angular/core';
import { StorageKey } from 'src/models/general/storage.key.enum';
import { BasePaginationService } from 'src/services/general/base.pagination.service';

@Injectable({
	providedIn: 'root'
})
export class OrderPaginationService extends BasePaginationService {
	constructor() {
		super();
		this.init(StorageKey.orderPagination);
	}

}


